<template lang="pug">
    div.media-list-control(:class="theClass")
        div.media-list-control__container(ref="container" :class="containerClass" :style="containerStyle")
            template(v-if="modeSlider")
                div.splide__track
                    div.splide__list
                        media-list-control-item.splide__slide(v-for="mediaItem in media" :key="mediaItem.id" :mediaItem="mediaItem"
                                :mode="mode" :squareAspect="squareAspect" :clickCallback="itemClickCallback" :style="itemSizerStyle"
                                @videoResize="videoResize")
                            template(v-slot:decorate)
                                slot(name="decorate-item" :mediaItem="mediaItem")

            template(v-else)
                div.media-list-control__item-sizer(:style="itemSizerStyle")
                media-list-control-item(v-for="mediaItem in media" :key="mediaItem.id" :mediaItem="mediaItem"
                        :mode="mode" :squareAspect="squareAspect" :clickCallback="itemClickCallback" :style="itemSizerStyle"
                        @videoResize="videoResize")
                    template(v-slot:decorate)
                        slot(name="decorate-item" :mediaItem="mediaItem")
</template>

<script>
import Masonry from 'masonry-layout'
import ImagesLoaded from 'imagesloaded'
import Splide from '@splidejs/splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

export default {
    name: 'media-list-control',

    props: {
        media: {
            type: Array,
            required: true,
        },
        mode: {
            type: String,
            validate: (v) => !v || ['masonry', 'slider', 'column', 'grid'].includes(v),
            default: 'masonry',
        },
        columns: {
            type: Number,
            default: 3,
        },
        squareAspect: {
            type: Boolean,
        },
        itemClickCallback: {
            type: Function,
        },
    },

    data() {
        return {
            masonry: null,
        }
    },

    computed: {
        modeMasonry() {
            return this.mode == 'masonry'
        },
        modeSlider() {
            return this.mode == 'slider'
        },
        modeColumn() {
            return this.mode == 'column'
        },
        modeGrid() {
            return this.mode == 'grid'
        },

        theClass() {
            return {
                'media-list-control--masonry': this.modeMasonry,
                'media-list-control--slider': this.modeSlider,
                'media-list-control--column': this.modeColumn,
                'media-list-control--grid': this.modeGrid,
            }
        },
        containerClass() {
            return {
                'splider': this.modeSlider,
            }
        },

        containerStyle() {
            if (this.modeGrid) {
                return {
                    'grid-template-columns': `repeat(${this.columns}, 1fr)`
                }
            }
        },
        itemSizerStyle() {
            if (this.modeMasonry) {
                return {
                    'width': `${100 / this.columns}%`,
                }
            }
        },
    },

    watch: {
        media() {
            this.$nextTick(() => this.initLayout())
        },
        mode() {
            this.$nextTick(() => this.initLayout())
        },
    },

    methods: {
        initLayout() {
            if (this.masonry) {
                this.masonry.destroy()
                this.masonry = null
            }

            if (this.modeMasonry) {
                this.initMasonryLayout()
            }
            else if (this.modeSlider) {
                this.initSliderLayout()
            }
        },

        initMasonryLayout() {
            const containerEl = this.$refs.container

            this.masonry = new Masonry(containerEl, {
                itemSelector: '.media-list-control__item',
                columnWidth: '.media-list-control__item-sizer',
                percentPosition: true,
                horizontalOrder: false,
            })

            ImagesLoaded(containerEl).on('progress', () => {
                this.masonry.layout()
            })
        },

        initSliderLayout() {
            const containerEl = this.$refs.container

            new Splide(containerEl, {
                rewind: true,
                gap: 16,
                pagination: false,
                arrows: false,
                autoWidth: true,
                height: '100%',
            }).mount()
        },

        videoResize() {
            if (this.modeMasonry && this.masonry) {
                this.masonry.layout()
            }
        },
    },

    mounted() {
        this.initLayout()
    },
}
</script>
